//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductContext} from '../../../context';
import {useEditProduct} from '../../../utils/editProduct';
import {debounce} from '../../../../../utils/functions';

const useStyles = makeStyles(theme => ({
  numberField: {
    width: '96px',
  },
}));

export default function ProductTaxedOfferPriceCell() {
  const classes = useStyles();

  const [product, setProduct] = useProductContext(product => {
    const taxes = product.taxes ?? [];
    const categoryTaxes = product.categoryTaxes ?? [];

    return {
      id: product.id,
      enabledProductVariant: !!product.productVariantSetting?.enabled,
      offerPrice: product.offerPrice,
      hasVariants:
        product.productVariantSetting?.variants &&
        product.productVariantSetting?.variants.length > 0,
      taxes: [...taxes, ...categoryTaxes]
        .map(parseFloat)
        .reduce((a, b) => a + b, 1),
      taxedOfferPrice: product.taxedOfferPrice,
    };
  });

  const defaultValue = (product.taxes * parseFloat(product.offerPrice)).toFixed(
    5
  );

  // const [value, setValue] = useState(product.taxedOfferPrice);

  const {editProduct} = useEditProduct(product ? product.id : '');

  const hasVariants = product.enabledProductVariant && product.hasVariants;

  const handleChange = price => {
    const withoutTaxPrice = price
      ? parseFloat(Number(price) / product.taxes).toFixed(5)
      : '';
    const offerPriceSetting = {
      offerPrice: price || undefined,
      enabled: price ? true : false,
    };

    setProduct({
      offerPriceSetting,
      offerPrice: withoutTaxPrice,
      taxedOfferPrice: price,
    });

    debounce(_ => {
      if (!price && price !== '') return;
      editProduct({
        offerPriceSetting,
      });
    }, 750)();
  };

  return (
    <TableCell align="right">
      <CustomTextField
        name="offer-price"
        className={classes.numberField}
        type="number"
        value={product.taxedOfferPrice}
        defaultValue={defaultValue}
        disabled={hasVariants}
        inputProps={{
          step: '0.01',
        }}
        onChange={e => handleChange(e.target.value)}
      />
    </TableCell>
  );
}
